// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sign-in-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.sign-in-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.sign-in-form__label {
  margin: 0;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
}

.sign-in-form__input {
  min-height: 46px;
  border-radius: 12px !important;
  border-color: #cfdaf0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.sign-in-form__input:hover {
  border-color: #91b8ff;
}

.sign-in-form__input.ant-input-affix-wrapper-focused,
.sign-in-form__input:focus,
.sign-in-form__input:focus-within {
  border-color: #1677ff;
  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.14);
}

.sign-in-form__input .ant-input {
  font-size: 15px;
}

.sign-in-form__input--error {
  border-color: #ff4d4f !important;
  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15);
}

.sign-in-form__error {
  margin: 0;
  font-size: 12px;
  color: #ff4d4f;
}

.sign-in-form__prefix {
  color: #8ca0bf;
}

.sign-in-form__submit {
  height: 46px;
  margin-top: 4px;
  border-radius: 12px !important;
  font-size: 15px;
  font-weight: 600;
}

.sign-in-form__submit .ant-spin-dot-item {
  background-color: #ffffff;
}

.sign-in-form__meta {
  margin: 2px 0 0;
  text-align: center;
  color: #667085;
  font-size: 14px;
}

.sign-in-form__meta a {
  color: #1677ff;
  font-weight: 600;
  text-decoration: none;
}

.sign-in-form__meta a:hover {
  text-decoration: underline;
}

.sign-in-form__meta--secondary {
  margin-top: 4px;
}

.sign-in-session {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sign-in-session__card {
  height: auto !important;
  padding: 0 !important;
  border: 1px solid #d6e4ff !important;
  border-radius: 16px !important;
  background: linear-gradient(130deg, #ffffff 0%, #f4f8ff 100%) !important;
}

.sign-in-session__card:hover {
  border-color: #91b8ff !important;
  background: linear-gradient(130deg, #ffffff 0%, #ecf3ff 100%) !important;
}

.sign-in-session__card-content {
  width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.sign-in-session__icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #1677ff;
  background: rgba(22, 119, 255, 0.12);
}

.sign-in-session__icon .anticon {
  font-size: 20px;
}

.sign-in-session__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.sign-in-session__company {
  color: #1d2939;
  font-size: 16px;
  font-weight: 700;
}

.sign-in-session__description {
  color: #667085;
  font-size: 13px;
}

.sign-in-session__logout {
  height: 44px;
  border-radius: 12px !important;
}

.sign-in-session__logout-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/auth/SignIn.sass"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAEF;;AAAA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAGF;;AADA;EACE,gBAAA;EACA,8BAAA;EACA,qBAAA;EACA,wDAAA;AAIF;;AAFA;EACE,qBAAA;AAKF;;AAHA;;;EAGE,qBAAA;EACA,8CAAA;AAMF;;AAJA;EACE,eAAA;AAOF;;AALA;EACE,gCAAA;EACA,6CAAA;AAQF;;AANA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AASF;;AAPA;EACE,cAAA;AAUF;;AARA;EACE,YAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;AAWF;;AATA;EACE,yBAAA;AAYF;;AAVA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAaF;;AAXA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAcF;;AAZA;EACE,0BAAA;AAeF;;AAbA;EACE,eAAA;AAgBF;;AAdA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAiBF;;AAfA;EACE,uBAAA;EACA,qBAAA;EACA,oCAAA;EACA,8BAAA;EACA,wEAAA;AAkBF;;AAhBA;EACE,gCAAA;EACA,wEAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,oCAAA;AAqBF;;AAnBA;EACE,eAAA;AAsBF;;AApBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAuBF;;AArBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAwBF;;AAtBA;EACE,cAAA;EACA,eAAA;AAyBF;;AAvBA;EACE,YAAA;EACA,8BAAA;AA0BF;;AAxBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;AA2BF","sourcesContent":[".sign-in-form\n  display: flex\n  flex-direction: column\n  gap: 14px\n\n.sign-in-form__field\n  display: flex\n  flex-direction: column\n  gap: 6px\n\n.sign-in-form__label\n  margin: 0\n  color: #344054\n  font-size: 14px\n  font-weight: 600\n\n.sign-in-form__input\n  min-height: 46px\n  border-radius: 12px !important\n  border-color: #cfdaf0\n  transition: border-color 0.2s ease, box-shadow 0.2s ease\n\n.sign-in-form__input:hover\n  border-color: #91b8ff\n\n.sign-in-form__input.ant-input-affix-wrapper-focused,\n.sign-in-form__input:focus,\n.sign-in-form__input:focus-within\n  border-color: #1677ff\n  box-shadow: 0 0 0 3px rgba(22, 119, 255, 0.14)\n\n.sign-in-form__input .ant-input\n  font-size: 15px\n\n.sign-in-form__input--error\n  border-color: #ff4d4f !important\n  box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.15)\n\n.sign-in-form__error\n  margin: 0\n  font-size: 12px\n  color: #ff4d4f\n\n.sign-in-form__prefix\n  color: #8ca0bf\n\n.sign-in-form__submit\n  height: 46px\n  margin-top: 4px\n  border-radius: 12px !important\n  font-size: 15px\n  font-weight: 600\n\n.sign-in-form__submit .ant-spin-dot-item\n  background-color: #ffffff\n\n.sign-in-form__meta\n  margin: 2px 0 0\n  text-align: center\n  color: #667085\n  font-size: 14px\n\n.sign-in-form__meta a\n  color: #1677ff\n  font-weight: 600\n  text-decoration: none\n\n.sign-in-form__meta a:hover\n  text-decoration: underline\n\n.sign-in-form__meta--secondary\n  margin-top: 4px\n\n.sign-in-session\n  display: flex\n  flex-direction: column\n  gap: 12px\n\n.sign-in-session__card\n  height: auto !important\n  padding: 0 !important\n  border: 1px solid #d6e4ff !important\n  border-radius: 16px !important\n  background: linear-gradient(130deg, #ffffff 0%, #f4f8ff 100%) !important\n\n.sign-in-session__card:hover\n  border-color: #91b8ff !important\n  background: linear-gradient(130deg, #ffffff 0%, #ecf3ff 100%) !important\n\n.sign-in-session__card-content\n  width: 100%\n  padding: 16px\n  display: flex\n  align-items: center\n  gap: 14px\n\n.sign-in-session__icon\n  width: 44px\n  height: 44px\n  border-radius: 50%\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  color: #1677ff\n  background: rgba(22, 119, 255, 0.12)\n\n.sign-in-session__icon .anticon\n  font-size: 20px\n\n.sign-in-session__text\n  display: flex\n  flex-direction: column\n  gap: 2px\n  text-align: left\n\n.sign-in-session__company\n  color: #1d2939\n  font-size: 16px\n  font-weight: 700\n\n.sign-in-session__description\n  color: #667085\n  font-size: 13px\n\n.sign-in-session__logout\n  height: 44px\n  border-radius: 12px !important\n\n.sign-in-session__logout-content\n  display: inline-flex\n  align-items: center\n  justify-content: center\n  gap: 8px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
